// extracted by mini-css-extract-plugin
export default {"container":"Programs_container__TEEr8","title":"Programs_title__ygJ2D","programsGrid":"Programs_programsGrid__T-Llu","programLogo":"Programs_programLogo__sJ-2b"};